
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-chip-group',
  standalone: true,
  imports: [],
  template: `
    <div class="flex flex-wrap gap-2 pb-1 pt-1">
      <ng-content />
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipGroupComponent {}
